// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202606031103/js/" + chunkId + "." + {"44":"78cd595c","225":"8f826178","481":"a2cd2e25","486":"ed84d757","770":"887f0e9c"}[chunkId] + ".0.3021461469577129.chunk.js";
};